<template>
  <!-- 编辑器 -->
  <div>
    <VueQuillEditor
      ref="text"
      v-model="editContent"
      :title="titleVal"
      :auth="authVal"
      :audio-list="audioList"
      :video-list="videoList"
      :selected-vote-id="selectedVoteId"
      :selected-exam-id="selectedExamId"
      :sm-program-link="smProgramLink"
      :options="editorOption"
      @getTitleVal="getTitleVal"
      @getAuthVal="getAuthVal"
      @getTextCount="getTextCount"
    />
  </div>
</template>

<script>
import VueQuillEditor from '../vue-quill-edit/editor.vue';
import _Quill from 'quill';
const Quill = window.Quill || _Quill;

export default {
  components: {
    VueQuillEditor,
  },
  props: [
    'content',
    'title',
    'auth',
    'imageList',
    'videoList',
    'audioList',
    'selectedVoteId',
    'selectedExamId',
    'smProgramLink',
  ],
  data() {
    return {
      // content: '<h2>这是内容</h2>',
      editContent: '',
      editorOption: {},
      authVal: '', // 作者
      titleVal: '', // 标题
    };
  },
  watch: {
    imageList(newval) {
      const { quill } = this.$refs.text;
      let index = 0;
      if (quill.getSelection()) {
        index = quill.getSelection().index;
      } else {
        index = quill.getLength();
      }
      const ATTRIBUTES = ['alt', 'height', 'width', 'wx_media_id', 'wx_media_url', 'publicInfo'];

      newval.map((item) => {
        const length = quill.selection.savedRange.index;
        const myimg = Quill.import('formats/image');

        class ImgBlot extends myimg {
          static create(value) {
            const publicInfo = JSON.stringify(value.public_list);
            const agentInfo = JSON.stringify(value.agent_list);
            const node = super.create();
            node.setAttribute('src', value.url); // 设置audio的src属性
            node.setAttribute('mate_id', value.mate_id); // 设置id

            node.setAttribute('mate_name', value.mate_name);
            node.setAttribute('mate_data', value.mate_data);
            node.setAttribute('publicInfo', publicInfo); // 设置一个id
            node.setAttribute('agentInfo', agentInfo); // 设置微信应用信息
            return node;
          }
          static formats(domNode) {
            return ATTRIBUTES.reduce(function (formats, attribute) {
              if (domNode.hasAttribute(attribute)) {
                formats[attribute] = domNode.getAttribute(attribute);
              }
              return formats;
            }, {});
          }

          format(name, value) {
            if (ATTRIBUTES.indexOf(name) > -1) {
              if (value) {
                this.domNode.setAttribute(name, value);
              } else {
                this.domNode.removeAttribute(name);
              }
            } else {
              super.format(name, value);
            }
          }
        }
        ImgBlot.blotName = 'img';
        ImgBlot.tagName = 'img'; // 自定义的标签为img
        Quill.register(ImgBlot);
        quill.insertEmbed(length, 'img', item, 'api');
        index += 1;
      });
      quill.setSelection(index);
    },
    editContent(newval) {
      this.$emit('getContent', newval);
    },
    title: {
      handler(newval) {
        this.titleVal = newval;
      },
      deep: true,
    },
    auth: {
      handler(newval) {
        this.authVal = newval;
      },
      deep: true,
    },
    content: {
      handler(newval) {
        this.editContent = newval;
      },
      deep: true,
    },
  },
  mounted() {
    // let quill = this.$refs.text.quill;
    // let length = quill.getLength();
    // console.log(quill.getLength(), "quill.getLength()");
    // quill.insertEmbed(quill.getLength(), "image", "src");
    // console.log(quill.getLength(), "quill.getLength()");
    // quill.formatText(length, quill.getLength(), {
    //   alt: "图片说明",
    //   width: 100,
    // });
  },
  methods: {
    getTitleVal(val) {
      this.$emit('getTitleVal', val);
    },
    getAuthVal(val) {
      this.$emit('getAuthVal', val);
    },
    getTextCount(val) {
      this.$emit('getTextCount', val);
    },
  },
};
</script>
<style lang="scss">
@import './index.scss';
</style>
